module.exports = __webpack_public_path__ + "img/15passenger_stopped.7994b772.svg";